import React from 'react';
import { oneOf, bool, string, shape } from 'prop-types';
import { CloseIcon } from '@ids/internal-icons';
import IconControl from './IconControl';

/** A controlled version of the close icon */
const CloseIconControl = React.forwardRef((props, ref) => (
  <IconControl ref={ref} {...props}>
    <CloseIcon />
  </IconControl>
));

CloseIconControl.propTypes = {
  /**
   * Whether  to use inverse theming, optional.
   */
  // eslint-disable-next-line react/boolean-prop-naming
  inverse: bool,
  /**
   * Specifies Button size, 'small', 'medium' or 'large'
   */
  size: oneOf(['small', 'medium', 'large']),
  /**
   * Aria label
   */
  'aria-label': string,
  /**
   * Label for the icon
   */
  label: string,
  /**
   * Position for the label
   */
  labelPosition: oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether icon is selected.
   */
  // eslint-disable-next-line react/boolean-prop-naming
  selected: bool,
  /**
   * Configurable color of icon in various states
   */
  iconColor: shape({
    default: string,
    selected: string,
    focus: string,
    hover: string,
    selectedBackground: string
  }),
  /**
   * Configurable color of label
   */
  labelColor: shape({
    default: string,
    selected: string
  })
};

CloseIconControl.defaultProps = {
  inverse: false,
  size: 'small',
  'aria-label': 'Close',
  label: '',
  labelPosition: 'right',
  selected: null,
  iconColor: undefined,
  labelColor: undefined
};

CloseIconControl.displayName = 'CloseIconControl';
export default CloseIconControl;
